import React from "react";
import { COLORS } from "../../theme";
import Card from "./Card";
import Avatar from "./Avatar";
import IconBadge from "./IconBadge";

// "1.15h" lido por qualquer humano parece "1h15" — mesma regra usada em
// todo lugar que mostra hora, duplicada aqui de propósito (padrão já
// adotado no resto do projeto pra esse helper).
function formatarHoras(horasDecimal) {
  const valor = horasDecimal || 0;
  const totalMin = Math.round(Math.abs(valor) * 60);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  const sinal = valor < 0 ? "-" : "";
  return `${sinal}${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

function ListaSaldo({ titulo, itens, cor, vazio }) {
  return (
    <Card style={{ padding: 0 }}>
      <div style={{ padding: "14px 20px", borderBottom: `1px solid ${COLORS.border}`, display: "flex", alignItems: "center", gap: 10 }}>
        <IconBadge icon="barChart" size={28} cor={cor} />
        <h2 style={{ fontSize: 13.5, fontWeight: 800, color: COLORS.text, margin: 0 }}>{titulo}</h2>
      </div>
      {itens.length === 0 ? (
        <p style={{ padding: "16px 20px", fontSize: 12.5, color: COLORS.textLight, margin: 0 }}>{vazio}</p>
      ) : (
        itens.map((f, i) => (
          <div key={f.funcionario_id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 20px", borderBottom: i < itens.length - 1 ? `1px solid ${COLORS.border}` : "none" }}>
            <Avatar nome={f.nome} size={28} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: COLORS.text }}>{f.nome}</div>
              {f.equipe && <div style={{ fontSize: 11, color: COLORS.textLight, marginTop: 1 }}>{f.equipe}</div>}
            </div>
            <span style={{ fontSize: 13, fontWeight: 700, color: cor, fontVariantNumeric: "tabular-nums" }}>{formatarHoras(f.saldo_final)}</span>
          </div>
        ))
      )}
    </Card>
  );
}

// Ranking de banco de horas — maiores/menores saldos do time, lado a lado.
// Reaproveitado no Dashboard (mês corrente, atualiza sozinho) e no
// Fechamento Mensal (mês escolhido) — mesmo formato, fonte de dado diferente.
export default function RankingSaldo({ maiores, menores }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 16 }}>
      <ListaSaldo titulo="Maiores saldos" itens={maiores} cor={COLORS.success} vazio="Ninguém com saldo positivo esse mês." />
      <ListaSaldo titulo="Menores saldos" itens={menores} cor={COLORS.danger} vazio="Ninguém com saldo negativo esse mês. 🎉" />
    </div>
  );
}
